$(function(){
  
  setupResizingForFooter();
  hideOrShowUl();

  $('footer .footerSection .title').click(function() {
    if ($(this).css('cursor') != 'pointer') return; // hack for this to work only on "mobile"  

    $(this).toggleClass('expanded').next().slideToggle(400);
  })
})

function hideOrShowUl() {
  if ($('footer .footerSection .title').css('cursor') == 'pointer') {
    $('footer .footerSection ul').hide();
  }
  else {
    $('footer .footerSection ul').show();
  }
}

function setupResizingForFooter() {
  var resizeTimer; 

  // On resize, run the function and reset the timeout
  $(window).resize(function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(hideOrShowUl, 300);
  });    
}